import type { FC } from 'react';

import { CircularProgress } from '@mui/material';

import useStyles from './LoaderOverlay.styles';

export type Props = {
  inner?: boolean;
  minHeight?: string;
};

const LoaderOverlay: FC<Props> = ({ inner, minHeight }) => {
  const { classes, cx } = useStyles({ minHeight });
  return (
    <div className={cx(inner ? classes.inner : classes.cover)}>
      <CircularProgress />
    </div>
  );
};

export default LoaderOverlay;
